const isExecuteKeyCode = (keyCode) => [13, 32].includes(keyCode);

export const onExecuteKeyDown = callback => event => {
  if (typeof callback !== 'function') {
    return null;
  }
  if (isExecuteKeyCode(event.keyCode)) {
    event.preventDefault();
    event.stopPropagation();
    return callback(event);
  }
}

export const onVerticalArrowNavigation = fetchItems => onArrowNavigation(fetchItems, 38, 40);

export const onHorizontalArrowNavigation = fetchItems => onArrowNavigation(fetchItems, 37, 39);

const onArrowNavigation = (fetchItems, backKeyCode, nextKeyCode) => event => {
  if (typeof fetchItems !== 'function') {
    return null;
  }
  const items = fetchItems();
  let focusFunction;

  if (isExecuteKeyCode(event.keyCode)) {
    focusFunction = focusNext;
  } else {
    switch (event.keyCode) {
    case backKeyCode:
      focusFunction = focusPrevious;
      break;
    case nextKeyCode:
      focusFunction = focusNext;
      break;
    }
  }
  if (focusFunction) {
    event.preventDefault();
    event.stopPropagation();
    focusFunction(items);
  }
}

const getActiveIndex = (items) => {
  if (!items || !items.length) {
    return;
  }
  return items.indexOf(document.activeElement);
}

const focusNext = (items) => {
  const activeIndex = getActiveIndex(items);
  if (typeof activeIndex === 'undefined') {
    return;
  }

  let nextIndex;
  if (activeIndex === -1) {
    nextIndex = 0;
  } else {
    nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
  }
  items[nextIndex].focus();
}

const focusPrevious = (items) => {
  const activeIndex = getActiveIndex(items);
  if (typeof activeIndex === 'undefined') {
    return;
  }

  let prevIndex;
  if (activeIndex === -1) {
    prevIndex = items.length - 1;
  } else {
    prevIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
  }
  items[prevIndex].focus();
}
